// extracted by mini-css-extract-plugin
module.exports = {"inputText":"inputGroupText_inputText__l7DFQ","inputDisabled":"inputGroupText_inputDisabled__2mE76","inputLabel":"inputGroupText_inputLabel__q8P7c"};